import React, { useEffect, useState } from 'react'

import { Checkbox, FormControlLabel } from '@mui/material'

interface Props {
  onChange?: (checked: boolean) => void
  value?: boolean
  label?: string | JSX.Element
  disabled?: boolean
}

const CheckBoxComponent: React.FC<Props> = (props: Props) => {
  const [value, setValue] = useState<boolean>(props.value || false)
  const disabled = props.disabled || false
  useEffect(() => {
    setValue(props.value || false)
  }, [props.value])

  return (
    <FormControlLabel
      sx={{ alignItems: 'flex-start' }}
      control={
        <Checkbox
          disabled={disabled}
          checked={value}
          onChange={(event) => props.onChange && props.onChange(event.target.checked)}
        />
      }
      label={props.label || ''}
    />
  )
}

export default CheckBoxComponent
